<template>
  <div class="battle-index-content" :id="unionId">
    <template v-if="mode === 'view' && !isLoadViewData">
      <div class="loading-container">
        <div v-if="fromEditor" class="loader-tip">点击进入阵容编辑器</div>
        <div v-else class="loader"></div>
      </div>
    </template>
    <template v-else>
      <div v-if="mode === 'edit'" class="header">
        <Tabs :value="currentTab" @change="handleChangeTab" />
        <div class="option">
          <el-button type="primary" class="btn" :loading="saveLoading" @click="handleSave">保存</el-button>
        </div>
      </div>
      <template v-if="mode === 'edit'">
        <div class="title">
          <input placeholder="请输入标题" v-model="title" type="text" />
        </div>
        <div class="option-line">
          <Round
            :value="currentRound"
            :showAdd="true"
            :total="roundInfos.length"
            @change="handleChangeRound"
            @add="handleAddRound"
          />
          <div class="right">
            <el-button :disabled="roundInfos.length <= 1" type="primary" class="btn" @click="handleDelRound"
              >删除此回合</el-button
            >
            <el-button type="primary" class="btn" @click="handleEditTeam">编辑本回合队伍</el-button>
          </div>
        </div>
      </template>
      <div v-else class="option-line">
        <div v-if="title" class="view-title">{{ title }}</div>
        <Round :value="currentRound" :showAdd="false" :total="roundInfos.length" @change="handleChangeRound" />
      </div>
      <div :class="['inner-box']">
        <BattleContainer
          ref="battleContainerRef"
          :mode="mode"
          :parentWidth="parentWidth"
          :battleType="currentTab"
          :unionSetting="currentRoundData.unionSetting"
          :currentRound="currentRound"
          :extraAdd="currentRoundData.extraAdd"
          :lastRoundExtraAdd="lastRoundData.extraAdd || 0"
          :isShowEnemy="isShowEnemy"
          @extra-add="handleChangeExtraSp"
          @change-show="handleChangeShow"
          @handle-edit-role="handleEditRole"
          @handle-edit-union="handleEditUnion"
          @handle-role-info="handleRoleInfo"
          @handle-our-sort-data="handleUpdateSortData"
          @handle-add-role="handleEditTeam"
        />
      </div>
      <div :class="['remark-box']">
        <el-input
          v-if="mode === 'edit'"
          type="textarea"
          :rows="5"
          placeholder="批注内容"
          v-model="roundInfos[currentRound].remark"
        ></el-input>
        <pre v-if="mode === 'view' && roundInfos[currentRound].remark">{{ roundInfos[currentRound].remark }}</pre>
      </div>
    </template>

    <EditTeam
      ref="editTemRef"
      :battleType="currentTab"
      :current="roundInfos[currentRound]"
      :roleList="roleList"
      @updateTeam="handleUpdateTeam"
    />
    <ExchangeModal ref="exchangeRef" @ok="handleExchange" />
    <EditRole ref="editRoleRef" :current="currentEditRoleData" @updateRole="handleUpdateRole" />
    <EditUnion ref="editUnionRef" :current="currentRoundData.unionSetting" @updateUnion="handleUpdateUnion" />
    <ViewRole ref="roleInfoRef" :current="currentShowRoleData" />
  </div>
</template>
<script>
import Tabs from "./tabs.vue";
import Round from "./round.vue";
import BattleContainer from "./battleContainer.vue";
import EditTeam from "./editTeam.vue";
import ExchangeModal from "./exchangeModal.vue";
import EditRole from "./editRole.vue";
import EditUnion from "./editUnion.vue";
import ViewRole from "./viewRole.vue";
import { apiGetBattleRoleList, apiAddBattle, apiEditBattle, apiGetBattleDetail } from "@/api/wiki-zsca";
import { createUniqueKey } from "@/plugins/util";

export default {
  components: {
    Tabs,
    Round,
    BattleContainer,
    EditTeam,
    EditRole,
    ExchangeModal,
    EditUnion,
    ViewRole
  },
  props: {
    unionKey: {
      type: String,
      default: ""
    },
    id: {
      type: Number,
      default: undefined
    },
    mode: {
      type: String,
      default: "view"
    },
    fromEditor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentRoundData() {
      return this.roundInfos[this.currentRound];
    },
    lastRoundData() {
      if (this.currentRound === 0) return {};
      return this.roundInfos[this.currentRound - 1];
    }
  },
  data() {
    return {
      // 1: 一般，2: 工会
      currentTab: 1,
      currentRound: 0,
      roleList: [],
      roundInfos: [
        {
          extraAdd: 0,
          ourPositionData: [],
          ourSortData: [],
          enemyData: [],
          remark: "",
          unionSetting: {
            actionType: "dead",
            skill: "救赎之击",
            level: 1
          }
        }
      ],
      parentWidth: 800,
      spSetting: {
        total: 0,
        roundAdd: 0
      },
      title: "",
      // 是否打开敌方角色
      isShowEnemy: true,
      // 当前编辑角色index
      currentEditRoleIndex: -1,
      // 当前编辑角色数据
      currentEditRoleData: {},
      // 当前查看角色数据
      currentShowRoleData: {},
      saveLoading: false,
      // 是否加载view模式数据
      isLoadViewData: true,
      currentId: undefined,
      unionId: ""
    };
  },
  mounted() {
    this.unionId = `battle-${createUniqueKey()}`;
    this.getParentWidth();
    if (this.mode === "edit") {
      this.getRoleList();
    }
    this.init();
  },
  methods: {
    getParentWidth() {
      setTimeout(() => {
        const dom = document.querySelector(`#${this.unionId}`);
        this.parentWidth = dom.offsetWidth;
        if (!this.parentWidth) {
          // 在页签里面
          const tabs = dom.closest(".w-editor-tabs-content");
          if (tabs) {
            const tabsWidth = parseFloat(window.getComputedStyle(tabs).width);
            this.parentWidth = tabsWidth;
          }
        }
      });
    },
    // 获取角色列表
    getRoleList() {
      apiGetBattleRoleList().then(res => {
        if (res.code === 0) {
          if (res.data && (res.data.role || res.data.pet)) {
            const result = [];
            res.data.role &&
              res.data.role.forEach(item => {
                if (item.children) {
                  item.children.forEach(child => {
                    result.push({
                      ...child,
                      type: "role"
                    });
                  });
                }
              });
            res.data.pet &&
              res.data.pet.forEach(item => {
                result.push({
                  ...item,
                  id: item.name,
                  star: "pet",
                  type: "pet"
                });
              });
            this.roleList = result;
          }
        }
        // this.roleList = res.data;
      });
    },
    // 初始化数据, 重置数据
    init() {
      if (this.unionKey) {
        if (this.mode === "view") {
          this.isLoadViewData = false;
        }
        this.getDetail();
        return;
      }

      this.setRoundData();
    },
    // 设置数据
    setRoundData() {
      const obj = {
        extraAdd: 0,
        ourPositionData: [],
        ourSortData: [],
        enemyData: [],
        remark: "",
        unionSetting: {
          actionType: "dead",
          skill: "救赎之击",
          level: 1
        }
      };
      let teamLength = 12;
      if (this.currentTab === 2) {
        teamLength = 25;
      }
      for (let i = 0; i < teamLength; i++) {
        obj.ourPositionData.push({
          type: 0
        });
        obj.enemyData.push({
          type: 0
        });
      }
      this.$set(this.roundInfos, 0, obj);
      this.handleSetData(true);
    },
    // 获取详情
    getDetail() {
      const params = {
        union_key: this.unionKey
      };
      apiGetBattleDetail(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            this.getParentWidth();
            this.isLoadViewData = true;
            this.$nextTick(() => {
              try {
                this.currentId = res.data.id;
                const content = JSON.parse(res.data.content);
                const { title, isShowEnemy, roundInfos, spSetting, unionSetting, currentTab } = content;

                this.title = title || "";
                this.isShowEnemy = isShowEnemy || false;
                this.currentTab = currentTab || 1;
                this.$emit("changeTab", currentTab);

                this.spSetting = spSetting || {
                  total: 0,
                  roundAdd: 0
                };
                this.currentRound = 0;

                if (roundInfos && roundInfos.length > 0) {
                  this.roundInfos = roundInfos.map(item => {
                    // 兼容一下老数据
                    return {
                      ...item,
                      unionSetting: item.unionSetting ||
                        unionSetting || {
                          actionType: "dead",
                          skill: "救赎之击",
                          level: 1
                        }
                    };
                  });
                } else {
                  this.setRoundData();
                }

                this.handleSetData(true);
              } catch (error) {
                this.setRoundData();
              }
            });
          } else {
            if (this.mode === "view") {
              if (!this.unionKey) {
                return;
              }
              const battleContainer = document.querySelector(`[data-unionkey="${this.unionKey}"]`);
              if (!battleContainer) return;
              if (this.unionKey) {
                setTimeout(() => {
                  this.getDetail();
                }, 5000);
              } else {
                this.setRoundData();
              }
            } else {
              this.setRoundData();
            }
          }
        })
        .catch(err => {
          if (this.mode === "view") {
            if (!this.unionKey) {
              return;
            }
            const battleContainer = document.querySelector(`[data-unionkey="${this.unionKey}"]`);
            if (!battleContainer) return;
            if (this.unionKey) {
              setTimeout(() => {
                this.getDetail();
              }, 5000);
            } else {
              this.setRoundData();
            }
          } else {
            this.setRoundData();
          }
        });
    },
    // 切换是否显示敌方角色
    handleChangeShow(value) {
      this.isShowEnemy = value;
    },
    // 保存
    handleSave() {
      // if (!this.title) {
      //   this.$message.warning("请输入标题");
      //   return;
      // }
      if (!this.roundInfos || this.roundInfos.length === 0) {
        this.$message.warning("请添加回合");
        return;
      }
      if (this.roundInfos.some(item => item.ourSortData.length === 0)) {
        this.$message.warning("请编辑队伍");
        return;
      }
      const params = {
        content: JSON.stringify({
          title: this.title,
          isShowEnemy: this.isShowEnemy,
          currentTab: this.currentTab,
          roundInfos: this.roundInfos,
          spSetting: this.spSetting
        })
      };
      let api;
      if (this.currentId) {
        params.union_key = this.unionKey;
        params.id = this.currentId;
        api = apiEditBattle;
      } else {
        params.union_key = this.unionKey || createUniqueKey();
        api = apiAddBattle;
      }
      this.saveLoading = true;
      api(params)
        .then(res => {
          if (res.code === 0) {
            // console.log("保存成功");
            //关闭页面
            window.close();
          }
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    // 点击切换
    handleChangeTab(key) {
      if (this.currentTab === key) return;
      this.$refs.exchangeRef.currentIndex = key;
      this.$refs.exchangeRef.visible = true;
    },
    // 确认切换, 清空数据
    handleExchange(index) {
      this.$emit("changeTab", index);
      this.currentTab = index;
      this.spSetting = {
        total: 0,
        roundAdd: 0
      };
      this.currentRound = 0;
      this.roundInfos = [
        {
          extraAdd: 0,
          ourPositionData: [],
          ourSortData: [],
          enemyData: [],
          remark: "",
          unionSetting: {
            actionType: "dead",
            skill: "救赎之击",
            level: 1
          }
        }
      ];
      this.setRoundData();
    },
    // 切换回合
    handleChangeRound(value) {
      if (this.currentRound === value) return;
      this.currentRound = value;
      this.handleSetData();
    },
    // 新增回合，复制前一个
    handleAddRound() {
      const lastOne = this.roundInfos[this.roundInfos.length - 1];
      const obj = JSON.parse(JSON.stringify(lastOne));
      this.roundInfos.push({
        ...obj,
        extraAdd: 0
      });
      this.currentRound = this.roundInfos.length - 1;
      this.handleSetData();
    },
    handleDelRound() {
      this.roundInfos.splice(this.currentRound, 1);
      this.currentRound = 0;
    },
    // 编辑队伍
    handleEditTeam() {
      this.$refs.editTemRef.visible = true;
    },
    // 更新队伍
    handleUpdateTeam(data) {
      const positionData = this.roundInfos[this.currentRound].ourPositionData;
      data.forEach(item => {
        const findIndex = positionData.findIndex(i => i.uniqueKey === item.uniqueKey);
        if (findIndex === -1) {
          const firstEmptyIndex = positionData.findIndex(i => i.type === 0);
          if (firstEmptyIndex !== -1) {
            this.$set(positionData, firstEmptyIndex, item);
          }
        }
      });
      // 过滤掉position中已经不在sort中的数据
      positionData.forEach((item, inde) => {
        if (item.type !== 0 && !data.find(i => i.uniqueKey === item.uniqueKey)) {
          this.$set(positionData, inde, {
            type: 0
          });
        }
      });
      this.$set(this.roundInfos[this.currentRound], "ourSortData", data);
      this.$set(this.roundInfos[this.currentRound], "ourPositionData", positionData);
      this.handleSetData();
    },
    // 更新角色
    handleUpdateRole(data) {
      const copyData = JSON.parse(JSON.stringify(data));
      this.$set(this.roundInfos[this.currentRound].ourSortData, this.currentEditRoleIndex, copyData);
      const findPositionIndex = this.roundInfos[this.currentRound].ourPositionData.findIndex(
        i => i.uniqueKey === data.uniqueKey
      );
      this.$set(this.roundInfos[this.currentRound].ourPositionData, findPositionIndex, copyData);
      this.handleSetData();
    },
    // 更新工会模式
    handleUpdateUnion(data) {
      this.$set(this.roundInfos[this.currentRound], "unionSetting", data);
      this.handleSetData();
    },
    // 更新排序数据
    handleUpdateSortData(data) {
      this.$set(this.roundInfos[this.currentRound], "ourSortData", data);
    },
    // 点击编辑角色
    handleEditRole(index, data) {
      this.currentEditRoleIndex = index;
      this.currentEditRoleData = JSON.parse(JSON.stringify(data));
      this.$nextTick(() => {
        this.$refs.editRoleRef.visible = true;
      });
    },
    // 点击查看角色信息
    handleRoleInfo(data) {
      this.currentShowRoleData = data;
      this.$nextTick(() => {
        this.$refs.roleInfoRef.visible = true;
      });
    },
    // 点击编辑工会模式
    handleEditUnion() {
      this.$refs.editUnionRef.visible = true;
    },
    // 额外增加本回合sp
    handleChangeExtraSp(value) {
      this.$set(this.roundInfos[this.currentRound], "extraAdd", value);
    },
    // 透传数据，将子组件数据更新
    handleSetData(changeSp = false) {
      this.$refs.battleContainerRef.initDatas(this.roundInfos[this.currentRound], changeSp ? this.spSetting : null);
    }
  }
};
</script>
<style lang="less" scoped>
.btn {
  color: #fff;
  background-color: #967a5f;
  border-color: transparent;
  &.is-disabled {
    background-color: #a0a0a0;
  }
}
.battle-index-content {
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
  box-sizing: border-box;
  // background-color: var(--zs-wiki-banner-bg);
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 454px;
    background: url("~@/assets/zs_imgs/battle/default_battle_bg.png") no-repeat;
    background-size: 100% 100%;
    .loader-tip {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
    .loader {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      display: inline-block;
      position: relative;
      border: 3px solid;
      border-color: transparent rgba(255, 255, 255, 0.54) rgba(255, 255, 255, 0.54);
      animation: rotation 2s linear infinite;
      margin: 20px;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;
    .option {
      display: flex;
      align-items: center;
    }
  }
  .title {
    width: 100%;
    margin-bottom: 20px;
    padding: 14px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    input {
      width: 100%;
      border: none;
      outline: none;
      color: #333;
      font-size: 28px;
      // placeholder颜色
      &::placeholder {
        color: #999;
      }
    }
  }
  .option-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    .view-title {
      color: #424242;
      font-size: 28px;
    }
  }
  .inner-box {
    margin-bottom: 16px;
    background-color: #f2f2f2;
  }
  /deep/.remark-box {
    width: 100%;
    background: #ededed;

    .el-textarea__inner {
      background: #ededed;
      border: none;
    }
    pre {
      min-height: 108px;
      padding: 12px;
      margin: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
